// Packages
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Other
import './styles.css';
import dayjs from 'dayjs';

const Datepicker = ({
    className = {},
    error = null,
    label = '',
    onChange = () => {alert('onChange is not set!')},
    placeholder = '',
    required = false,
    styles = {},
    tabIndex = 0,
    type = 'datetime',
    value = null,
}) => {

    const [active, setActive] = useState(false);

    const currentYear = new Date().getFullYear();

    // Create an array of the next ten years, including the present one
    const years = Array.from({ length: 10 }, (_, index) => currentYear + index);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    useEffect(() => {

        if( value != null && value != '' ) {

            setActive(true);
        }
        else {

            setActive(false)
        }
    }, [value])


    return(
        <div className={`Datepicker ${className}`} style={styles}>
            {/* <label className={`Datepicker__label ${active ? 'active' : ''}`}>{label ?? ''}
            </label> */}
            <ReactDatePicker 
                calendarClassName="Datepicker__calendar"
                className="Datepicker__input" 
                renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                    }) => (
                        <div
                            style={{
                                margin: 10,
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                            {"<"}
                        </button>
                        <select
                            value={dayjs(date).format('YYYY')}
                            onChange={({ target: { value } }) => changeYear(value)}
                        >
                            {years.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
            
                        <select
                            value={months[dayjs(date).format('M') - 1]}
                            onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                            }
                        >
                            {months.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                            ))}
                        </select>
                
                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                            {">"}
                        </button>
                        </div>
                    )}
                placeholderText={placeholder}
                popperClassName="Datepicker__popper"
                popperPlacement="bottom-start"
                popperModifiers={[
                    {
                        name: 'arrow',
                        options: {
                            padding: 36,
                        },
                    },
                ]}
                showTimeSelect={type !== 'date'}
                showTimeSelectOnly={type === 'time'}
                tabIndex={tabIndex ?? 0}
                timeFormat="HH:mm"
                timeIntervals={5}
                timeCaption="time"
                dateFormat="do MMM yyyy"
                onChange={(value) => {onChange(dayjs(value).format('YYYY-MM-DD HH:mm'))}} 
                required={required} 
                selected={value ? new Date(Date.parse(value)) : null}
            />
            {error &&
                <p className='Datepicker__error red'>{error}</p>
            }
        </div>
    )
}

Datepicker.propTypes = {
    className: PropTypes.object,
    description: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    label: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    styles: PropTypes.object,
    tabIndex: PropTypes.number,
    type: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    width: PropTypes.string
}

export default Datepicker;                                         